import React, { useEffect, useState } from 'react';

import * as formatters from '../../../utils/formatters';

import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import Search from '../../elements/Search';
import ViewButton from '../../elements/ViewButton';
import BooleanIcon from '../../elements/booleanIcon';
import Paginator from '../../elements/paginator';
import TableDataValue from '../../elements/tableDataValue';
import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';
import { TableCell as Cell, EMPTY_CELL } from 'crm/elements/common/TableDetailsRow';
import TableHead from 'crm/elements/common/TableHead';
import {PERMISSION} from "../../helpers/Permissions";

const currencyCode = process.env.MIX_CURRENCY;

export function getPromoCodeBonusDisplay(bonus) {
    switch (bonus) {
        case 'ticket':
            return 'Ticket';
        case 'percentage_discount':
            return 'Discount (%)';
        case 'amount_discount':
            return `Discount (${currencyCode})`;
        default:
            return EMPTY_CELL;
    }
}

function PromoCodeCampaigns() {
    const [campaigns, setCampaigns] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [filter, setFilter] = useState('');
    const url = '/crea/api/promocode';
    const { formatDate, formatCurrency } = formatters;

    const getCampaigns = (page) => {
        let requestUrl = url;
        requestUrl += `?page=${page}`;
        axios.get(requestUrl, { params: { filter } }).then((response) => {
            setCampaigns(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
    };

    useEffect((page = 1) => {
        getCampaigns(page);
    }, []);

    useEffect(() => {
        getCampaigns();
    }, [filter]);

    function getPromoCodesList() {
        return campaigns.map((campaign) => (
            <tr key={campaign.id}>
                <td>
                    <ViewButton url={`/promo_codes/${campaign.id}`} permissions={[PERMISSION.VIEW_PROMO_CODE]} />
                    <EditButton url={`/promo_codes/${campaign.id}/edit`} permissions={[PERMISSION.UPDATE_PROMO_CODE]} />
                    {parseInt(campaign.total_uses) === 0 && (
                        <DeleteButton
                            url={`${url}/${campaign.id}`}
                            action={() => getCampaigns(currentPage)}
                            permissions={[PERMISSION.DELETE_PROMO_CODE]}
                        />
                    )}
                </td>
                <Cell>{campaign.prefix}</Cell>
                <Cell>{campaign.use_place}</Cell>
                <Cell>{getPromoCodeBonusDisplay(campaign.bonus)}</Cell>
                <Cell>{campaign.affiliate_name}</Cell>
                <Cell>{campaign.lottery_name}</Cell>
                <Cell>
                    {campaign.bonus === 'percentage_discount' ? (
                        `${campaign.discount_amount ?? 0}%`
                    ) : (
                        <TableDataValue value={formatCurrency(campaign.discount_amount)} />
                    )}
                </Cell>
                <Cell>{formatDate(campaign.start_date, true)}</Cell>
                <Cell>{formatDate(campaign.end_date, true)}</Cell>
                <td>
                    <BooleanIcon value={campaign.is_enabled} />
                </td>
            </tr>
        ));
    }

    return (
        <>
            <ActionButton title="Create new promo code" url="/promo_codes/create" permissions={[PERMISSION.CREATE_PROMO_CODE]} />
            <Card title="Promo Codes">
                <Search filterTable={(value) => setFilter(value)} />
                <div className="table-responsive">
                    <table className="table model-list">
                        <TableHead>
                            <div />
                            <th>Prefix</th>
                            <th>Use place</th>
                            <th>Bonus</th>
                            <th>Affiliate</th>
                            <th>Lottery</th>
                            <th>Discount amount</th>
                            <th>Start date</th>
                            <th>End date</th>
                            <th>Active</th>
                        </TableHead>
                        <tbody>{getPromoCodesList()}</tbody>
                    </table>
                    <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getCampaigns} />
                </div>
            </Card>
        </>
    );
}

export default PromoCodeCampaigns;
